var _circle, _path, _rect, _rect2, _circle2, _path2, _g, _circle3, _path3, _circle4, _circle5, _circle6, _path4, _path5, _line, _line2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoGraderHomePageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 138,
    viewBox: "0 0 219 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 78.9189,
    r: 35,
    fill: "#F58120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.464 74.0469C126.84 74.0469 126.344 74.1989 125.976 74.5029C125.624 74.7909 125.448 75.1829 125.448 75.6789C125.448 76.1589 125.664 76.5429 126.096 76.8309C126.544 77.1189 127.56 77.4629 129.144 77.8629C130.744 78.2469 131.984 78.8309 132.864 79.6149C133.744 80.3989 134.184 81.5429 134.184 83.0469C134.184 84.5509 133.616 85.7749 132.48 86.7189C131.36 87.6469 129.88 88.1109 128.04 88.1109C125.384 88.1109 122.992 87.1269 120.864 85.1589L123.096 82.4229C124.904 84.0069 126.576 84.7989 128.112 84.7989C128.8 84.7989 129.336 84.6549 129.72 84.3669C130.12 84.0629 130.32 83.6629 130.32 83.1669C130.32 82.6549 130.112 82.2549 129.696 81.9669C129.28 81.6629 128.456 81.3589 127.224 81.0549C125.272 80.5909 123.84 79.9909 122.928 79.2549C122.032 78.5029 121.584 77.3349 121.584 75.7509C121.584 74.1509 122.152 72.9189 123.288 72.0549C124.44 71.1909 125.872 70.7589 127.584 70.7589C128.704 70.7589 129.824 70.9509 130.944 71.3349C132.064 71.7189 133.04 72.2629 133.872 72.9669L131.976 75.7029C130.52 74.5989 129.016 74.0469 127.464 74.0469ZM149.945 71.1429V74.4789H141.593V77.9349H149.105V81.1269H141.593V84.6069H150.209V87.9189H137.849V71.1429H149.945ZM166.614 79.4469C166.614 77.9429 166.134 76.6629 165.174 75.6069C164.214 74.5509 163.03 74.0229 161.622 74.0229C160.23 74.0229 159.054 74.5509 158.094 75.6069C157.134 76.6629 156.654 77.9429 156.654 79.4469C156.654 80.9349 157.134 82.2069 158.094 83.2629C159.054 84.3029 160.23 84.8229 161.622 84.8229C163.03 84.8229 164.214 84.3029 165.174 83.2629C166.134 82.2069 166.614 80.9349 166.614 79.4469ZM167.886 85.6149C166.19 87.2629 164.102 88.0869 161.622 88.0869C159.142 88.0869 157.054 87.2629 155.358 85.6149C153.662 83.9509 152.814 81.8869 152.814 79.4229C152.814 76.9589 153.662 74.9029 155.358 73.2549C157.054 71.5909 159.142 70.7589 161.622 70.7589C164.102 70.7589 166.19 71.5909 167.886 73.2549C169.582 74.9029 170.43 76.9589 170.43 79.4229C170.43 81.8869 169.582 83.9509 167.886 85.6149Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 194.303,
    y: 72.1885,
    width: 2,
    height: 7,
    transform: "rotate(-25.9869 194.303 72.1885)",
    fill: "#F58120"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 196.471,
    y: 78.9189,
    width: 4,
    height: 11,
    transform: "rotate(-25.9869 196.471 78.9189)",
    fill: "#192657"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.713,
    cy: 61.6322,
    r: 12,
    transform: "rotate(-25.9869 189.713 61.6322)",
    fill: "white",
    stroke: "#192657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181 66.9189C177.8 60.9189 181.333 55.4189 183.5 53.4189C181.499 57.9189 184 61.4189 192 64.4189C198.4 66.8189 196.333 69.7523 194.5 70.9189C187.7 73.7189 182.666 69.4189 181 66.9189Z",
    fill: "#F58120"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.168 39.0043C109.573 32.2849 107.977 25.5962 104.581 19.7839C101.185 13.9717 96.1417 9.29709 90.0889 6.35116C84.0361 3.40524 77.2456 2.32034 70.5762 3.23366C63.9068 4.14699 57.658 7.01751 52.62 11.4822C47.582 15.947 43.9811 21.8054 42.2726 28.3166C40.5641 34.8278 40.8249 41.6995 43.0218 48.0625C45.2187 54.4256 49.2531 59.9943 54.6149 64.0645C59.9767 68.1347 66.425 70.5235 73.1445 70.9288L73.2327 69.466C66.8026 69.0781 60.6319 66.7921 55.501 62.8972C50.3701 59.0023 46.5094 53.6734 44.407 47.5843C42.3047 41.4952 42.0553 34.9194 43.6902 28.6885C45.3251 22.4577 48.7709 16.8515 53.592 12.579C58.4131 8.30656 64.3928 5.55964 70.775 4.68564C77.1573 3.81164 83.6553 4.84983 89.4475 7.6689C95.2397 10.488 100.066 14.9613 103.316 20.5233C106.566 26.0852 108.093 32.486 107.705 38.9161L109.168 39.0043Z",
    fill: "#1E334E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.855 28.248H112.52C116.386 28.248 119.52 31.3821 119.52 35.248V43.4109C119.52 47.2769 116.386 50.4109 112.52 50.4109H106.855L107.251 39.3295L106.855 28.248Z",
    fill: "#1E334E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5327 28.248H38.6597C34.7937 28.248 31.6597 31.3821 31.6597 35.248V43.4109C31.6597 47.2769 34.7937 50.4109 38.6597 50.4109H44.3242L43.5327 38.9337V28.248Z",
    fill: "#1E334E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.74919,
    cy: 49.6193,
    r: 3.74919,
    stroke: "#528FF5",
    strokeWidth: 2
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.7323,
    cy: 104.005,
    r: 5,
    transform: "rotate(38.5306 70.7323 104.005)",
    fill: "#192657"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1289 73.1484L70.573 102.6L96.8592 89.6562",
    stroke: "#192657"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.3162,
    cy: 91.1413,
    r: 5,
    transform: "rotate(38.5306 96.3162 91.1413)",
    fill: "#1098F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.9764,
    cy: 74.945,
    r: 5,
    transform: "rotate(38.5306 75.9764 74.945)",
    fill: "#F58120"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 27.9189,
    r: 6,
    fill: "#192657"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171 135.919H194V113.919",
    stroke: "#192657",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 133.919V114.919C187.1 128.919 177 133.419 172.5 133.919H191.5Z",
    fill: "#528FF5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 109,
    y1: 112.419,
    x2: 141,
    y2: 112.419,
    stroke: "#192657"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 119,
    y1: 116.419,
    x2: 141,
    y2: 116.419,
    stroke: "#192657"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5005 39.9191C66.8338 65.7525 37.0005 120.719 83.0005 133.919C140.5 150.419 203.5 95.9191 217 116.419C230.5 136.919 151.5 140.419 172.5 39.9191C193.5 -60.5809 224 64.4191 205.5 71.9191",
    stroke: "#192657",
    strokeWidth: 0.5,
    strokeDasharray: "2 2 2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoGraderHomePageIcon);
export default __webpack_public_path__ + "static/media/seoGraderHomePageIcon.8dab6b9a001843ef65acce6b94224f5a.svg";
export { ForwardRef as ReactComponent };